import { createReducer } from "@reduxjs/toolkit";

import { setUiKey, toggleLoader, toggleUiModal } from "store/actions";

/** ***************** 
@purpose : Intital ui reducer data
@Author : INIC
***************** */
const initialState = {
  isLoading: false,
  messages: [],
  modals: {},
  loaders: {
    page: false,
  },
};

/** ***************** 
  @purpose : UI Reducer
  @Parameter : {ui_ini_data, action}
  @Author : INIC
  ***************** */

const uiReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setUiKey, (state, action) => {
      state[action.payload[action.key]] = action.payload.data;
    })
    .addCase(toggleUiModal, (state, action) => {
      state.modals[action.key] = action.value;
    })
    .addCase(toggleLoader, (state, action) => {
      state.loaders[action.keys] = action.value;
    });
});

export default uiReducer;
